<template>
  <div class="layer-filter-buttons">
    <div class="filter-btn-box">
      <div class="filter-btn-box">
        <a
          href="#"
          class="btn my-v-btn"
          @click="onClick(CLICK_EVENT.ON_MY_VESSELS)"
          ><span class="material-icons visibility-icon">{{
            myVesselIconName
          }}</span
          >自社船</a
        >
        <a
          href="#"
          class="btn other-v-btn"
          @click="onClick(CLICK_EVENT.ON_OTHER_VESSELS)"
          ><span class="material-icons visibility-icon">{{
            otherVesselIconName
          }}</span
          >一般船</a
        >
        <a
          href="#"
          class="btn rg-obj-btn"
          @click="onClick(CLICK_EVENT.ON_RG_OBJECT)"
          ><span class="material-icons visibility-icon">{{
            rgObjectIconName
          }}</span
          >その他</a
        >
        <a
          v-if="showPrivatePlot"
          href="#"
          class="btn p-plot-btn"
          @click="onClick(CLICK_EVENT.ON_PRIVATE_PLOT)"
          ><span class="material-icons visibility-icon">{{
            privatePlotIconName
          }}</span
          >プロット</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayerFilterButtons",
  components: {},
  props: {
    showPrivatePlot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CLICK_EVENT: {
        ON_MY_VESSELS: 1,
        ON_OTHER_VESSELS: 2,
        ON_RG_OBJECT: 3,
        ON_PRIVATE_PLOT: 4,
        ON_TRACK: 10,
      },
      localLayerFilters: {
        isMyVesselVisibility: true,
        isOtherVesselVisibility: true,
        isRgObjectVisibility: true,
        isPrivatePlotVisibility: true,
      },
    };
  },
  computed: {
    myVesselIconName() {
      return this.getIconName(this.localLayerFilters.isMyVesselVisibility);
    },
    otherVesselIconName() {
      return this.getIconName(this.localLayerFilters.isOtherVesselVisibility);
    },
    rgObjectIconName() {
      return this.getIconName(this.localLayerFilters.isRgObjectVisibility);
    },
    privatePlotIconName() {
      return this.getIconName(this.localLayerFilters.isPrivatePlotVisibility);
    },
  },
  methods: {
    onClick(e) {
      switch (e) {
        case this.CLICK_EVENT.ON_MY_VESSELS:
          this.localLayerFilters.isMyVesselVisibility =
            !this.localLayerFilters.isMyVesselVisibility;
          this.sendEvent();
          break;
        case this.CLICK_EVENT.ON_OTHER_VESSELS:
          this.localLayerFilters.isOtherVesselVisibility =
            !this.localLayerFilters.isOtherVesselVisibility;
          this.sendEvent();
          break;
        case this.CLICK_EVENT.ON_RG_OBJECT:
          this.localLayerFilters.isRgObjectVisibility =
            !this.localLayerFilters.isRgObjectVisibility;
          this.sendEvent();
          break;
        case this.CLICK_EVENT.ON_PRIVATE_PLOT:
          this.localLayerFilters.isPrivatePlotVisibility =
            !this.localLayerFilters.isPrivatePlotVisibility;
          this.sendEvent();
          break;
        default:
          break;
      }
    },
    getIconName(isVisibility) {
      return isVisibility ? "visibility" : "visibility_off";
    },
    sendEvent() {
      this.$emit("updateLayerFilters", this.localLayerFilters);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.filter-btn-box {
  display: flex;
  flex-basis: 70%;
  justify-content: flex-end;

  .btn {
    margin-right: 5px;
    width: 80px;
    padding: 5px;
    border-radius: 5px;
    display: block;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    text-decoration: none;
    text-align: center;
  }

  .my-v-btn {
    display: flex;
    justify-content: center;
  }

  .other-v-btn {
    display: flex;
    justify-content: center;
  }

  .rg-obj-btn {
    display: flex;
    width: 90px;
    justify-content: center;
  }

  .p-plot-btn {
    display: flex;
    width: 110px;
    justify-content: center;
  }

  .track-btn {
    display: flex;
    justify-content: center;
  }

  .visibility-icon {
    color: $aisea-white;
    font-size: 18px;
    margin-right: 6px;
  }
}
</style>
